import { apiClient } from './client'

export type ReportFormat = 'xlsx'

export interface SheetDay {
  sign_in: string | null
  sign_out: string | null
  hours: number | null
  less: boolean
  wfh: boolean
  /** The specific leave type taken that day (e.g. "casual"/"sick"/"annual"), null when not on leave. */
  leave_type: string | null
  in_range: boolean
}

export interface SheetEmployee {
  sr: number
  name: string
  cl: number
  sl: number
  /** Per-leave-type weekly counts, keyed by whatever types are configured
   * (e.g. "annual") — total_leaves sums all of them. */
  leave_type_counts: Record<string, number>
  total_leaves: number
  wfh: number
  weekly_hours: number
  weekly_less: boolean
  days: SheetDay[]
}

export interface SheetWeek {
  dates: string[]
  in_range: boolean[]
  weekday_names: string[]
  employees: SheetEmployee[]
}

export interface AttendanceSheet {
  title: string
  start: string
  end: string
  weeks: SheetWeek[]
}

export interface SheetParams {
  start: string
  end: string
  user_ids?: string[]
  department_id?: string
}

export async function getAttendanceSheet(params: SheetParams): Promise<AttendanceSheet> {
  return (await apiClient.get<AttendanceSheet>('/analytics/attendance-sheet', {
    params: { start: params.start, end: params.end, user_ids: params.user_ids, department_id: params.department_id },
    paramsSerializer: { indexes: null }, // repeat ?user_ids= for each
  })).data
}

/** Trigger a browser download of a Blob. */
function saveBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}

export async function exportAttendanceSheet(params: SheetParams): Promise<void> {
  const response = await apiClient.get('/analytics/attendance-summary/export', {
    params: { start: params.start, end: params.end, user_ids: params.user_ids, department_id: params.department_id },
    paramsSerializer: { indexes: null },
    responseType: 'blob',
  })
  saveBlob(response.data as Blob, `attendance-${params.start}-${params.end}.xlsx`)
}
